import { createAppAsyncThunk } from '../../store/extensions';
import { CreateMedicationDto, UpdateMedicationDto } from './dtos';
import {
  deleteMedicationCall,
  fetchMedicationsCall,
  insertMedicationsCall,
  searchMedicationsCall,
  updateMedicationCall,
} from './service';

export const fetchMedications = createAppAsyncThunk(
  'healthjourney/medication/getAll',
  (healthjourneyId: string) => {
    return fetchMedicationsCall(healthjourneyId);
  }
);

export const searchMedications = createAppAsyncThunk(
  'healthjourney/medication/searchMedications',
  (searchString: string) => {
    return searchMedicationsCall(searchString);
  }
);

export const insertMedications = createAppAsyncThunk(
  'healthjourney/medication/insert',
  (newMedications: CreateMedicationDto[]) => {
    return insertMedicationsCall(newMedications);
  }
);

export const updateMedication = createAppAsyncThunk(
  'healthjourney/medication/update',
  (medication: UpdateMedicationDto) => {
    return updateMedicationCall(medication);
  }
);

export const deleteMedication = createAppAsyncThunk(
  'healthjourney/medication/delete',
  (medicationId: string) => {
    return deleteMedicationCall(medicationId);
  }
);
